import { useAuth } from '@on3/ui-lib/index';
import { type IModalAction, Modal } from 'components/UI/Modal/Modal';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useMemo, useState } from 'react';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const AthleteClaimModal = () => {
  const claimAttempted = cookies.get('claimAttempt');
  const [open, setOpen] = useState(claimAttempted ?? false);
  const { user, refreshToken } = useAuth();
  const { query } = useRouter();

  const success = query.success as string;
  const isSuccessed = success === '1';

  const handleClose = useCallback(() => {
    cookies.remove('claimAttempt', { path: '/rivals' });
    setOpen(false);
  }, []);

  const isSuccessClaim = claimAttempted && isSuccessed;
  const renderTitle = isSuccessClaim
    ? `Congratulations ${user?.a} you have successfully linked your social account.`
    : 'Sorry there was a problem. Please make sure you are trying to claim your profile. Please refresh and try again. If the problem happens again, email athletenetwork@on3.com and include your player profile';

  const actions: IModalAction[] = useMemo(
    () => [
      {
        text: 'Close',
        color: 'primary',
        onPress: handleClose,
      },
    ],
    [handleClose],
  );

  useEffect(() => {
    claimAttempted && refreshToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      actions={actions}
      messageText={renderTitle}
      open={open}
      setOpen={setOpen}
      titleText="Recruits"
    />
  );
};
